module.exports = __webpack_public_path__ + "static/media/branding-img3.509f3b67.jpg";